import { createActionGroup, props } from '@ngrx/store';
import { AppLockState, ModelNameFlags } from '@rocksoft/settings-sdk';
import { CategoryType, ErrorModel, type AppleBundleIdentifier } from '@rocksoft/shared';
import { Category } from '../router/category';

// ============================================================================
// API ACTIONS
// ============================================================================

export const AppLockApiActions = createActionGroup({
  source: 'App Lock API',
  events: {
    'App lock set error': props<{ category: Category; error: ErrorModel }>(),
    'App lock removed error': props<{ category: Category; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryAppLockViewActions = createActionGroup({
  source: 'Category app lock view',
  events: {
    'App lock selected': props<{
      categoryType: CategoryType;
      bundleIdentifier: AppleBundleIdentifier;
      modelNames: ModelNameFlags[];
      appLockState: AppLockState;
    }>(),
    'App lock removed': props<{
      categoryType: CategoryType;
      bundleIdentifier: AppleBundleIdentifier;
      modelNames: ModelNameFlags[];
      appLockState: AppLockState;
    }>(),
  },
});
